<template>
  <div class="megatabs__panel-right">
    <nav class="fridge-navigation">
      <fridge-navigation></fridge-navigation>
      <a
        href="#"
        class="sec-link sec-1"
        :class="{ active: isSectionInViewport('.R_section_content__1') }"
        v-scroll-to="{
            el: '.R_section_content__1 .function-box-main',
            duration: 200,
            easing: 'linear',
            offset: -70
        }"
      >CoolZone</a>
      <a
        href="#"
        class="sec-link sec-2"
        :class="{ active: isSectionInViewport('.R_section_content__2') }"
        v-scroll-to="{
            el: '.R_section_content__2 .function-box-main',
            duration: 200,
            easing: 'linear',
            offset: -70
        }"
      >AdaptZone</a>
      <a
        href="#"
        class="sec-link sec-3"
        :class="{ active: isSectionInViewport('.R_section_content__3') }"
        v-scroll-to="{
            el: '.R_section_content__3 .function-box-main',
            duration: 200,
            easing: 'linear',
            offset: -70
        }"
      >FreezeZone</a>
    </nav>
    <div class="L_fridge_wrapper" :style="`top:${fridgeOffsetTop}px;`">
      <div class="L_fridge">
        <div
          class="fridge-pin fridge-pin--s1-1 fridge-pin-section-1"
          :class="{ 'pin-active': sectionOneActivePinIndex == 1 }"
          @click.prevent="onSectionOnePinClick(1)"
        >
          <span>{{ pl ? 'Deska do wina i serów' : 'Wine and cheese board (with cover)' }}</span>
        </div>
        <!-- <div
          class="fridge-pin fridge-pin--s1-2 fridge-pin-section-1"
          :class="{ 'pin-active': sectionOneActivePinIndex == 2 }"
          @click.prevent="onSectionOnePinClick(2)"
        >
          <span>Brak danych</span>
        </div>-->
        <div
          class="fridge-pin fridge-pin--s1-3 fridge-pin-section-1"
          :class="{ 'pin-active': sectionOneActivePinIndex == 3 }"
          @click.prevent="onSectionOnePinClick(3)"
        >
          <span>FlexiShelf</span>
        </div>
        <div
          class="fridge-pin fridge-pin--s1-4 fridge-pin-section-1"
          :class="{ 'pin-active': sectionOneActivePinIndex == 4 }"
          @click.prevent="onSectionOnePinClick(4)"
        >
          <span>{{ pl ? 'Pojemnik na warzywa i owoce' : 'Fruit and vegetable container' }}</span>
        </div>
        <div
          class="fridge-pin fridge-pin--s1-5 fridge-pin-section-1"
          :class="{ 'pin-active': sectionOneActivePinIndex == 5 }"
          @click.prevent="onSectionOnePinClick(5)"
        >
          <span>SnackBox</span>
        </div>
        <div
          class="fridge-pin fridge-pin--s1-6 fridge-pin-section-1"
          :class="{ 'pin-active': sectionOneActivePinIndex == 6 }"
          @click.prevent="onSectionOnePinClick(6)"
        >
          <span>DoorShelf</span>
        </div>
        <!--  -->
        <div
          class="fridge-pin fridge-pin--s2-1 fridge-pin-section-2"
          :class="{ 'pin-active': sectionTwoActivePinIndex == 1 }"
          @click.prevent="onSectionTwoPinClick(1)"
        >
          <span>AdaptZone</span>
        </div>
        <div
          class="fridge-pin fridge-pin--s2-2 fridge-pin-section-2"
          :class="{ 'pin-active': sectionTwoActivePinIndex == 2 }"
          @click.prevent="onSectionTwoPinClick(2)"
        >
          <span>VitControl</span>
        </div>
        <!--  -->
        <div
          class="fridge-pin fridge-pin--s3-1 fridge-pin-section-3"
          :class="{ 'pin-active': sectionThreeActivePinIndex == 1 }"
          @click.prevent="onSectionThreePinClick(1)"
        >
          <span>{{ pl ? 'Pierwsza szuflada' : 'First drawer' }}</span>
        </div>
        <div
          class="fridge-pin fridge-pin--s3-2 fridge-pin-section-3"
          :class="{ 'pin-active': sectionThreeActivePinIndex == 2 }"
          @click.prevent="onSectionThreePinClick(2)"
        >
          <span>{{ pl ? 'Druga szuflada' : 'Second drawer' }}</span>
        </div>
        <div
          class="fridge-pin fridge-pin--s3-3 fridge-pin-section-3"
          :class="{ 'pin-active': sectionThreeActivePinIndex == 3 }"
          @click.prevent="onSectionThreePinClick(3)"
        >
          <span>{{ pl ? 'Trzecia szuflada' : 'Third drawer' }}</span>
        </div>
      </div>
    </div>

    <div ref="leftpanel_parallax">
      <section class="R_section_wrapper">
        <div class="R_section_content R_section_content__1">
          <div class="function-box-main">
            <span class="function-box__titleabove">SpaceManagement System</span>
            <span class="function-box__name">CoolZone</span>
            <span class="function-box__subtitle">{{ pl ? 'Komora chłodziarki' : 'Fridge compartment' }}</span>
            <p>
              {{ pl ? 'Sprytne rozwiązania w komorze chłodziarki pomogą Ci właściwie przechowywać produkty, dzięki czemu w Twojej kuchni nic się nie zmarnuje.' : 'The smart solutions in the fridge compartment will help you to store food properly; consequently, nothing will go to waste in your kitchen. ' }}
            </p>
          </div>
          <!--  -->
          <div class="function-box-bordered function-box-bordered--lightblue">
            <div class="function-box-bordered__icontitle">
              <div
                v-if="getFunctionField(sectionOneActivePinIndex, 'section-one', 'icon')"
                class="icontitle__icon"
              >
                <img :src="getFunctionField(sectionOneActivePinIndex, 'section-one', 'icon')" alt />
              </div>
              <div
                class="icontitle__name"
                v-html="getFunctionField(sectionOneActivePinIndex, 'section-one', 'title')"
              ></div>
            </div>
            <div
              v-if="getFunctionField(sectionOneActivePinIndex, 'section-one', 'image') == 'animated'"
              class="function-image-animated"
              :class="'function-image-animated-sectionone-' + sectionOneActivePinIndex"
            ></div>
            <img
              v-else
              class="function-image"
              :src="getFunctionField(sectionOneActivePinIndex, 'section-one', 'image')"
              alt
            />
            <p>
              {{
              getFunctionField(
              sectionOneActivePinIndex,
              "section-one",
              "copy"
              )
              }}
            </p>
          </div>
          <!--  -->
        </div>
      </section>
      <section class="R_section_wrapper">
        <div class="R_section_content R_section_content__2">
          <div class="function-box-main">
            <span class="function-box__titleabove">SpaceManagement System</span>
            <span class="function-box__name">AdaptZone</span>
            <span class="function-box__subtitle">{{ pl ? 'Szuflada' : 'Drawer' }}</span>
            <p>
              {{ pl ? 'Przechowuj w szufladzie AdaptZone najbardziej wymagające produkty.' : 'Store the most sensitive food products in the AdaptZone drawer' }}
            </p>
          </div>
          <!--  -->
          <div class="function-box-bordered function-box-bordered--lightgreen">
            <div class="function-box-bordered__icontitle">
              <div
                v-if="getFunctionField(sectionTwoActivePinIndex, 'section-two', 'icon')"
                class="icontitle__icon"
              >
                <img :src="getFunctionField(sectionTwoActivePinIndex, 'section-two', 'icon')" alt />
              </div>
              <div
                class="icontitle__name"
                v-html="getFunctionField(sectionTwoActivePinIndex, 'section-two', 'title')"
              ></div>
            </div>
            <img
              class="function-image"
              :src="getFunctionField(sectionTwoActivePinIndex, 'section-two', 'image')"
              alt
            />
            <p v-html="getFunctionField(sectionTwoActivePinIndex, 'section-two', 'copy')"></p>
          </div>
          <!--  -->
        </div>
      </section>
      <section class="R_section_wrapper R_section_wrapper--last">
        <div class="R_section_content R_section_content__3">
          <div class="function-box-main">
            <span class="function-box__titleabove">SpaceManagement System</span>
            <span class="function-box__name">FreezeZone</span>
            <span class="function-box__subtitle">{{ pl ? 'Szuflady zamrażarki' : 'Freezer drawers' }}</span>
            <p>
              {{
                pl
                ? 'Ułatwienia już na pierwszy rzut oka! Otwierasz zamrażarkę i od razu wiesz, gdzie co jest – nie musisz wysuwać po kolei wszystkich szuflad i sprawdzać! Ikony nadrukowane na szufladach podpowiedzą, gdzie umieścić produkt. W wybranych modelach identyfikację produktów ułatwią też kolorowe szuflady.'
                : 'Convenience at first glance! You open the freezer and know right away where things are, without opening all the drawers to check! The icons printed on the drawers are hints of where to place specific products. In selected models, product identification is further enhanced by coloured drawers.'
              }}
            </p>
          </div>
          <!--  -->
          <div class="function-box-bordered function-box-bordered--darkblue">
            <div class="function-box-bordered__icontitle">
              <div
                v-if="getFunctionField(sectionThreeActivePinIndex, 'section-three', 'icon')"
                class="icontitle__icon"
              >
                <img
                  :src="getFunctionField(sectionThreeActivePinIndex, 'section-three', 'icon')"
                  alt
                />
              </div>
              <div
                class="icontitle__name"
                v-html="getFunctionField(sectionThreeActivePinIndex, 'section-three', 'title')"
              ></div>
            </div>
            <img
              class="function-image"
              :src="getFunctionField(sectionThreeActivePinIndex, 'section-three', 'image')"
              alt
            />
            <p>
                {{ getFunctionField(sectionThreeActivePinIndex, 'section-three', 'copy') }}
            </p>
            <ul>
                <li v-for="(element, index) in getFunctionField(sectionThreeActivePinIndex, 'section-three', 'list')" v-bind:key="'el-three-index-' + index">
                    {{ element }}
                </li>
            </ul>
          </div>
          <!--  -->
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import FridgeNavigation from "./FridgeNavigation";

export default {
  props: ["component_data"],
  data() {
    return {
      parallaxSectionOffsetTop: 0,
      parallaxSectionOffsetLeft: 0,
      sectionOneActivePinIndex: 1,
      sectionTwoActivePinIndex: 2,
      sectionThreeActivePinIndex: 1
    };
  },
  computed: {
    fridgeOffsetTop() {
      return (
        this.parallaxSectionOffsetTop * 0.32 - this.parallaxSectionOffsetTop
      ); // 5.255 to współczynnik  wynikający z proporcji 411px przesunięcia pomiędzy częściami lodówki a 2160px odległości pomiędzy centrami sekcji
    }
  },
  mounted() {
    this.handleScroll();
  },
  methods: {
    handleScroll() {
      let leftPanelParallax = this.$refs.leftpanel_parallax;
      let sectionWrapperRef = this.$refs.section_wrapper_ref;

      if (leftPanelParallax) {
        var bounding = leftPanelParallax.getBoundingClientRect();
        if (bounding.top <= -60 && bounding.top > -3470) {
          this.parallaxSectionOffsetTop = bounding.top;
        } else if (bounding.top <= -3470) {
          this.parallaxSectionOffsetTop = -3470;
        } else {
          this.parallaxSectionOffsetTop = -60;
        }
      }

      if (sectionWrapperRef) {
        let sectionWrapperBounding = sectionWrapperRef.getBoundingClientRect();
        this.parallaxSectionOffsetLeft = sectionWrapperBounding.left;
      }
    },
    onSectionOnePinClick: function(pin_index) {
      this.sectionOneActivePinIndex = pin_index;
      this.$scrollTo(".R_section_content__1 .function-box-main", 200, {
        easing: "linear",
        offset: -70
      });
    },
    onSectionTwoPinClick: function(pin_index) {
      this.sectionTwoActivePinIndex = pin_index;
      this.$scrollTo(".R_section_content__2 .function-box-main", 200, {
        easing: "linear",
        offset: -70
      });
    },
    onSectionThreePinClick: function(pin_index) {
      this.sectionThreeActivePinIndex = pin_index;
      this.$scrollTo(".R_section_content__3 .function-box-main", 200, {
        easing: "linear",
        offset: -70
      });
    },
    getFunctionField(index, section, field_name) {
      return this.component_data.functions[section].find(
        obj => obj.id == index
      )[field_name];
    },
    inViewport(el) {
      var elH = el.offsetHeight,
        H = window.innerHeight,
        r = el.getBoundingClientRect(),
        t = r.top,
        b = r.bottom;
      return Math.max(0, t > 0 ? Math.min(elH, H - t) : b < H ? b : H);
    },
    isSectionInViewport(selector) {
      let sec = document.querySelector(selector);
      if (sec) {
        return this.inViewport(sec) > 500 ? true : false;
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  components: {
    FridgeNavigation
  }
};
</script>

<style lang="scss" scoped>
.megatabs__panel-right section:nth-child(even) {
  // background: rgba(211, 211, 211, 0.295);
}

.fridge-navigation {
  position: fixed;
  left: 70px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  width: 100px;

  @media only screen and (max-width: 1600px) {
    display: none;
  }

  .sec-link {
    width: 70px;
    position: absolute;
    left: 10px;
    border: none;
    background: #e8e6e1;
    border-radius: 10px;
    font-size: 11px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #625d52;

    &:active,
    &:focus,
    &:hover {
      outline: none;
      text-decoration: none;
    }

    &.sec-1 {
      top: 10px;
      height: 91px;

      &.active {
        background: #5bc4f0;
        color: #fff;
      }
    }

    &.sec-2 {
      top: 107px;
      height: 41px;

      &.active {
        background: #85de43;
        color: #fff;
      }
    }

    &.sec-3 {
      top: 163px;
      height: 61px;

      &.active {
        background: #001691;
        color: #fff;
      }
    }
  }
}

.R_section_wrapper {
  height: 84.375vw;
  position: relative;

  &.R_section_wrapper--last {
    height: 56.25vw;
  }

  .R_section_content {
    height: 56.25vw;
    width: 46vw;

    padding-right: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;

    &.R_section_content__1 {
      padding-top: 40px;
    }

    &.R_section_content__3 {
      justify-content: flex-end;
    }

    .function-box-main {
      display: flex;
      flex-direction: column;
      width: 480px;
      margin-bottom: 20px;

      .function-box__titleabove {
        color: #27241d;
        font-size: 14px;
        margin-bottom: 10px;
      }

      .function-box__name {
        color: #e41429;
        font-size: 44px;
        line-height: 42px;
        font-weight: 600;
      }

      .function-box__subtitle {
        color: #e41429;
        font-size: 34px;
        line-height: 42px;
        font-weight: 400;
        margin-bottom: 20px;
      }

      p {
        color: #27241d;
        font-size: 16px;
        line-height: 23px;
        font-family: "Lato";
        font-weight: 300;
        margin-bottom: 30px;
      }
    }

    .function-box-bordered {
      display: flex;
      flex-direction: column;
      width: 520px;
      position: relative;

      border-radius: 10px;
      padding: 40px;
      margin-bottom: 10px;

      .function-image {
        width: 440px;
        border-radius: 10px;
        object-fit: cover;
      }

      .function-image-animated {
        width: 100%;
        padding-top: 54.12%;
        // background: red;
        margin-bottom: 15px;
        border-radius: 10px;
      }

      &.function-box-bordered--lightblue {
        background: #f7fdff;
        border: 2px #5bc4f0 solid;
      }

      &.function-box-bordered--lightgreen {
        background: #fafff7;
        border: 2px #85de43 solid;
      }

      &.function-box-bordered--darkblue {
        background: #f8f9ff;
        border: 2px #001691 solid;
      }

      .function-box-bordered__icontitle {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 20px;

        .icontitle__icon {
          width: 70px;
          height: 70px;
          background: #e41429;
          margin-right: 20px;
          border-radius: 7px;
          flex: 0 0 auto;
        }

        .icontitle__name {
          color: #e41429;
          font-size: 34px;
          line-height: 38px;
          font-weight: 600;
        }
      }

      & > img {
        width: 100%;
        margin-bottom: 15px;
      }

      p {
        color: #27241d;
        font-size: 16px;
        line-height: 23px;
        font-family: "Lato";
        font-weight: 300;
      }

      ul {
          padding-left: 20px;
          margin-bottom: 0px;

          li {
            color: #27241d;
            font-size: 16px;
            line-height: 23px;
            font-family: "Lato";
            font-weight: 300;
          }
      }

      .function-box-bordered__video {
        display: flex;
        flex-direction: row;
        align-items: center;

        font-family: "Lato";
        color: #fff;
        font-size: 16px;
        font-weight: 300;
        letter-spacing: 0.3px;
        background: #5bc4f0;
        width: 240px;
        height: 60px;
        border-radius: 10px;

        position: absolute;
        bottom: 0px;
        left: 40px;
        transition: all 0.1s ease-in-out;
        transform: translateY(50%);

        &:hover {
          background: #3caede;
          text-decoration: none;
        }

        &:after {
          content: url("data:image/svg+xml;base64,CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTkuOTk2IiBoZWlnaHQ9IjE1Ljg0NyIgdmlld0JveD0iMCAwIDE5Ljk5NiAxNS44NDciPjxkZWZzPjxzdHlsZT4uYXtmaWxsOiNkNWYyZmY7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJhIiBkPSJNMTguNTksMTIuOTEzSDNhLjk5Ljk5LDAsMSwxLDAtMS45ODFIMTguNTlsLTUuMy01LjI0OWEuOTg1Ljk4NSwwLDAsMS0uMzE0LS45ODYsMSwxLDAsMCwxLC43NDMtLjcyNiwxLjAwNiwxLjAwNiwwLDAsMSwuOTkxLjMyNWw3LDYuOTMzYS45ODQuOTg0LDAsMCwxLDAsMS4zODdsLTcsNi45MzNhMS4wMDcsMS4wMDcsMCwwLDEtMS4zNTgtLjA0Mi45ODQuOTg0LDAsMCwxLS4wNjItMS4zNDRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMiAtMy45NDUpIi8+PC9zdmc+");
          position: absolute;
          top: 54%;
          right: 25px;
          transform: translateY(-50%);
        }

        .video__thumb {
          height: 60px;
          width: 60px;
          margin-right: 20px;

          border-radius: 10px;
          background-position: 50% 50%;
          background-size: contain;
        }
      }
    }
  }
}

.L_fridge_wrapper {
  width: 49.4791vw;
  position: absolute;
  right: 0px;

  .L_fridge {
    width: 49.4791vw;
    padding-top: 210.421%;
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/lodowka_right.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 10;

    .fridge-pin {
      position: absolute;
      width: 40px;
      height: 40px;
      background: #fff;
      border-radius: 10px;
      cursor: pointer;
      z-index: 2;
      // transition: all 0.1s ease-in-out;

      &:before {
        content: "";
        width: 12px;
        height: 2px;

        position: absolute;
        top: 17px;
        left: 12px;
        border-radius: 99px;
        transition: all 0.1s ease-in-out;
      }

      &:after {
        content: "";
        width: 2px;
        height: 12px;

        position: absolute;
        top: 12px;
        left: 17px;
        border-radius: 99px;
        transition: all 0.1s ease-in-out;
      }

      &.fridge-pin-section-1 {
        border: 2px #5bc4f0 solid;

        &:after,
        &:before {
          background: #5bc4f0;
        }

        &:hover,
        &.pin-active {
          background: #5bc4f0;

          & > span {
            background: #5bc4f0;
            border: 2px #5bc4f0 solid;
          }
        }
      }

      &.fridge-pin-section-2 {
        border: 2px #85de43 solid;

        &:after,
        &:before {
          background: #85de43;
        }

        &:hover,
        &.pin-active {
          background: #85de43;

          & > span {
            background: #85de43;
            border: 2px #85de43 solid;
          }
        }
      }

      &.fridge-pin-section-3 {
        border: 2px #001691 solid;

        &:after,
        &:before {
          background: #001691;
        }

        &:hover,
        &.pin-active {
          background: #001691;

          & > span {
            background: #001691;
            border: 2px #001691 solid;
          }
        }
      }

      &:hover,
      &.pin-active {
        &:after,
        &:before {
          background: #fff;
          transform: rotate(45deg);
        }

        & > span {
          display: block;
          line-height: 35px;
        }
      }

      & > span {
        display: none;
        align-items: center;
        height: calc(100% + 4px);
        font-family: "Uni Neue";
        padding-right: 10px;
        padding-left: 10px;
        font-size: 12px;
        color: #fff;
        position: absolute;
        left: calc(100% - 6px);
        top: -2px;
        white-space: nowrap;
        font-weight: 600;
        background: #5bc4f0;
        border-left: none;
        border-radius: 0 10px 10px 0;
        letter-spacing: 0.2px;
        z-index: 2;
      }

      &.fridge-pin--s1-1 {
        top: 23.5%;
        left: 16%;
      }

      &.fridge-pin--s1-2 {
        top: 14%;
        left: 34%;
      }

      &.fridge-pin--s1-3 {
        top: 18%;
        left: 34%;
      }

      &.fridge-pin--s1-4 {
        top: 37.75%;
        left: 34%;
      }

      &.fridge-pin--s1-5 {
        top: 25%;
        left: 62%;
      }

      &.fridge-pin--s1-6 {
        top: 36%;
        left: 62%;
      }

      &.fridge-pin--s2-1 {
        top: 48%;
        left: 21%;
      }

      &.fridge-pin--s2-2 {
        top: 44.5%;
        left: 34%;
      }

      &.fridge-pin--s3-1 {
        top: 64%;
        left: 30%;
      }

      &.fridge-pin--s3-2 {
        top: 71.5%;
        left: 30%;
      }

      &.fridge-pin--s3-3 {
        top: 82.5%;
        left: 30%;
      }
    }
  }
}

// SNACKBOX
.function-image-animated-sectionone-5 {
  background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/snackbox.jpg");
  background-position: 50% 50%;
  background-size: cover;
  animation: snackBoxAnimation 8s linear infinite;
  background-repeat: no-repeat;
}

// FLEXISHELF
.function-image-animated-sectionone-3 {
  background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/flexishelf1.jpg");
  background-position: 50% 50%;
  background-size: cover;
  animation: flexiShelfAnimation 8s linear infinite;
  background-repeat: no-repeat;
}

.function-image-animated-sectionone-6 {
  background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/doorshelf1.jpg");
  background-position: 50% 50%;
  background-size: cover;
  animation: doorShelfAnimation 8s linear infinite;
  background-repeat: no-repeat;
}

.function-image-animated-sectionone-1 {
  background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/deskadowinaiserow1.jpg");
  background-position: 50% 50%;
  background-size: cover;
  animation: deskaSerowAnimation 8s linear infinite;
  background-repeat: no-repeat;
}

@keyframes snackBoxAnimation {
  0% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/snackbox.jpg");
  }
  30% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/snackbox.jpg");
  }
  35% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/snackbox2.jpg");
  }
  65% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/snackbox2.jpg");
  }
  70% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/snackbox3.jpg");
  }
  95% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/snackbox3.jpg");
  }
  100% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/snackbox.jpg");
  }
}

@keyframes flexiShelfAnimation {
  0% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/flexishelf1.jpg");
  }
  45% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/flexishelf1.jpg");
  }
  55% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/flexishelf2.jpg");
  }
  90% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/flexishelf2.jpg");
  }
  100% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/flexishelf1.jpg");
  }
}

@keyframes doorShelfAnimation {
  0% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/doorshelf1.jpg");
  }
  45% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/doorshelf1.jpg");
  }
  55% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/doorshelf2.jpg");
  }
  90% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/doorshelf2.jpg");
  }
  100% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/doorshelf1.jpg");
  }
}

@keyframes deskaSerowAnimation {
  0% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/deskadowinaiserow1.jpg");
  }
  45% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/deskadowinaiserow1.jpg");
  }
  55% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/deskadowinaiserow2.jpg");
  }
  90% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/deskadowinaiserow2.jpg");
  }
  100% {
    background-image: url("https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/deskadowinaiserow1.jpg");
  }
}
</style>
